export default __webpack_public_path__ + "static/media/help-circle.605c5b87.svg";